<template>
    <Multiselect
        v-bind="$attrs"
        :select-label="selectLabelComputed"
        :select-group-label="selectGroupLabelComputed"
        :selected-label="selectedLabelComputed"
        :deselect-label="deselectLabelComputed"
        :deselect-group-label="deselectGroupLabelComputed"
        :placeholder="placeholderComputed"
        :tag-placeholder="tagPlaceholderComputed"
    />
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'VMultiselect',
    compatConfig: { MODE: 3 },
    components: { Multiselect },
    inheritAttrs: false,
    props: {
        selectLabel: String,
        selectGroupLabel: String,
        selectedLabel: String,
        deselectLabel: String,
        deselectGroupLabel: String,
        placeholder: String,
        tagPlaceholder: String,
    },
    computed: {
        selectLabelComputed() {
            return this.selectLabel !== undefined ? this.selectLabel : this.trans('generic.multiselect-select')
        },
        selectGroupLabelComputed() {
            return this.selectGroupLabel !== undefined ? this.selectGroupLabel : this.trans('generic.multiselect-selectGroup')
        },
        selectedLabelComputed() {
            return this.selectedLabel !== undefined ? this.selectedLabel : this.trans('generic.multiselect-selected')
        },
        deselectLabelComputed() {
            return this.deselectLabel !== undefined ? this.deselectLabel : this.trans('generic.multiselect-deselect')
        },
        deselectGroupLabelComputed() {
            return this.deselectGroupLabel !== undefined ? this.deselectGroupLabel : this.trans('generic.multiselect-deselectGroup')
        },
        placeholderComputed() {
            return this.placeholder !== undefined ? this.placeholder : this.trans('generic.multiselect-placeholder')
        },
        tagPlaceholderComputed() {
            return this.tagPlaceholder !== undefined ? this.tagPlaceholder : this.trans('generic.multiselect-tag-placeholder')
        },
    },
}
</script>
